<template>
  <div id="DocDetail" class="page doc-detail flex-container flex-column">
    <back-header :title="name" :styles="{background: '#2E2E2E', color: '#ffffff'}"/>
    <iframe :src="url" frameborder="0" scrolling="auto" width="100%" height="100%" class="iframe"></iframe>
  </div>
</template>

<script>
import BackHeader from '@/components/business/BackHeader'
export default {
  name: 'DocDetail',
  components: { BackHeader },
  data() {
    return {
      name: this.$route.query.name || '返回',
      url: this.$route.query.url
    }
  },
}
</script>

<style lang="less" scoped>
  .doc-detail{
    height: 100%;
  }
  .iframe{
    flex: 1;
  }
</style>
